import * as yup from 'yup';

export const validationSchema = yup.object({
    name: yup
        .string()
        .required("Required"),
    metricType: yup.
        string().
        required("Required"),
    mTypeDisplay: yup.
        string().
        required("Required"),
    description: yup
        .string()
        .required("Required"),
    deciPlaceDigit: yup
        .string()
        .required("Required"),
})

export const initialValues = {
    name: "",
    metricType: "",
    mTypeDisplay:"",
    description:"",
    deciPlaceDigit:"",
    status: true,   
}